import React from 'react';

interface DebugLabelProps {
  label: string;
  type?: 'page' | 'component' | 'section' | 'layout';
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  className?: string;
}

export const DebugLabel: React.FC<DebugLabelProps> = () => null;